export function addNotification(data, userId, { icon, title, body }) {
  const notif = { id: `n_${Date.now()}_${Math.random().toString(36).slice(2)}`, userId, icon, title, body, date: Date.now(), read: false };
  return { ...data, notifications: [...(data.notifications || []), notif] };
}

export function markNotifsRead(data, userId) {
  return { ...data, notifications: (data.notifications || []).map(n => n.userId === userId ? { ...n, read: true } : n) };
}
